<!--broker and company bank list dropdown-->
<template>
  <div>
  <v-select
    v-model="localSelected"
    dense
    multiple
    :items="list"
    :ref="'bankSelect-' + item.id"
    item-text="name"
    append-icon=""
    :menu-props="{ value: openSelectedId === item.id, maxHeight: 'none' }"
    class="select-bank"
    item-value="id"
  >
    <!--icon-->
    <template v-slot:prepend>
      <v-btn
        data-testid="links-open"
        class="d-flex align-center"
        color="primary"
        @click.stop="$emit('open', item)"
        :disabled="disabled"
        :loading="loading"
      >
        <v-icon>{{ icon }}</v-icon>
        <v-icon small>{{
          openSelectedId === item.id ? "mdi-arrow-up" : "mdi-arrow-down"
        }}</v-icon>
      </v-btn>
    </template>

    <!--header-->
    <template v-slot:prepend-item>
      <div data-testid="links-menu" :data-entity-id="item.id" class="d-flex align-center justify-space-between my-1 py-0">
        <v-list-item>
          <v-list-item-content>
            <h6 class="text-uppercase font-weight-bold caption">
              {{ title }} FROM {{ item.name }}
            </h6>
            <p class="mb-0 pb-0 text-caption grey--text">{{ desc }}</p>
          </v-list-item-content>
        </v-list-item>
        <div class="mx-2">
          <v-btn icon @click="$emit('open', null)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />
      <v-divider v-else />
    </template>

    <!--bank list items-->
    <template v-slot:item="{ item: row, on, attrs }">
      <v-list-item
        v-on="on"
        v-bind="attrs"
        data-testid="linked-entity"
        :data-entity-id="row.id || row"
        style="border-bottom: thin solid rgba(255, 255, 255, 0.12)"
      >
        <div
          style="width: 100%"
          class="d-flex flex-column align-start justify-start my-2 pa-0"
        >
          <div style="width: 100%" class="d-flex flex-row flex-grow-1 justify-space-between align-center">
            <div class="d-flex flex-gap-2 align-center">
              <v-chip v-if="type === 'broker' && row.is_override" outlined color="primary" small>
                {{ row.is_override }}
              </v-chip>
              <div class="admin-bank-name font-weight-medium">{{ row.name }}</div>
            </div>

            <v-btn
              data-testid="unlink-entity"
              @click.stop="requestDelete(row)"
              :disabled="loading"
              icon
              small
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </v-list-item>
    </template>

    <!--add bank selector-->
    <template v-slot:append-item>
      <v-divider />
      <v-list-item>
        <v-list-item-content>
          <div class="d-flex flex-row align-center flex-gap-2 my-1">
            <v-select
              data-testid="link-entity"
              @click.stop
              v-model="entityToAdd"
              @change="onAddSelect"
              item-text="name"
              item-value="id"
              :items="availableItems ? availableItems(item) : []"
              :disabled="loading"
              label="Select entity to add"
              outlined
              dense
              hide-details
              class="admin-add-select"
            />
          </div>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>

  <delete-modal
    v-model="deleteDialog"
    :loading="loading"
    :item-label="pendingDelete ? pendingDelete.label : ''"
    @confirm="confirmDelete"
  />
  </div>
</template>
<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'

export default {
  components: { DeleteModal },
  props: {
    item: { type: Object },
    icon: { type: String },
    bankList: { type: Array },
    title: { type: String },
    desc: { type: String },
    overrideSelected: {
      type: Array,
      default: () => [],
    },
    openSelectedId: {
      type: [String, Number, null],
      default: null,
    },
    availableItems: {
      type: Function,
    },
    type: {
      // 'broker' | 'company'
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSelected: [],
      deleteDialog: false,
      pendingDelete: null,
      entityToAdd: null,
    };
  },
  watch: {
    overrideSelected: {
      immediate: true,
      handler(v) {
        this.localSelected = v || [];
      },
    },
  },
  computed: {
    list() {
      if (!this.item) return [];
      return this.item.banklist || [];
    },
  },
  methods: {
    onAddSelect(id) {
      if (!id) return;
      this.$emit('add', { item: this.item, id });
      // Reset dropdown input so selection does not remain filled
      this.$nextTick(() => {
        this.entityToAdd = null;
      });
    },
    requestDelete (row) {
      this.pendingDelete = { id: row.id, label: row.name || String(row.id) }
      this.deleteDialog = true
    },
    confirmDelete () {
      if (!this.pendingDelete) return
      const deleteId = this.pendingDelete.id
      this.deleteDialog = false
      this.pendingDelete = null
      this.$emit('delete', { item: this.item, id: deleteId })
    }
  },
  emits: ["update:selected", "open", "toggle-override", "add", "delete"],
};
</script>

<style scoped>
.admin-bank-name {
  font-size: 0.95rem;
}
::v-deep .admin-add-select .v-select__selections {
  font-size: 0.95rem;
}
::v-deep .v-list-item__title {
  font-size: 0.95rem !important;
}
</style>
